
<div class="info-progress-wrapper">
  <div class="progress-circle-container">
    <svg class="progress-circle" width="24" height="24" viewBox="0 0 24 24">
      <circle class="progress-circle-bg" cx="12" cy="12" r="10" fill="none" stroke-width="2" />
      <circle class="progress-circle-value" cx="12" cy="12" r="10" fill="none" stroke-width="2" :style="{ strokeDashoffset: progressOffset }" />
    </svg>
    <span class="info-icon">i</span>
  </div>
</div>
